import {createHorizontalEventOccurrenceElement} from "./createHorizontalEventOccurrenceElement";

export class EventOccurrencesContainerHandler {
  private sidebarContainer: HTMLElement | null = null;
  private modalEventOccurrencesContainer: HTMLElement | null = null;
  private application: any | null = null;

  initialize = (sidebarContainer: HTMLElement,
                modalEventOccurrencesContainer: HTMLElement,
                application: any) => {
    this.sidebarContainer = sidebarContainer;
    this.modalEventOccurrencesContainer = modalEventOccurrencesContainer;
    this.application = application;
  }

  show = (eventOccurrences: any) => {
    if (window.matchMedia("(max-width: 768px)").matches) {
      if (!this.modalEventOccurrencesContainer) { return; }

      const fragment = document.createDocumentFragment();

      for (const jsonItem of eventOccurrences) {
        const eventOccurrenceElement = createHorizontalEventOccurrenceElement(jsonItem);
        if (eventOccurrenceElement) fragment.append(eventOccurrenceElement);
      }

      const modalEventOccurrencesContent = this.modalEventOccurrencesContainer.querySelector('#modal-event-occurrences-content');
      if (modalEventOccurrencesContent) modalEventOccurrencesContent.replaceChildren(fragment);

      const contentModalController = this.application.getControllerForElementAndIdentifier(
        this.modalEventOccurrencesContainer!, 'public--map--modal-event-occurrences'
      ) as any;

      contentModalController.open();
    } else {
      if (!this.sidebarContainer) { return; }

      const fragment = document.createDocumentFragment();

      for (const jsonItem of eventOccurrences) {
        const eventOccurrenceElement = createHorizontalEventOccurrenceElement(jsonItem)
        if (eventOccurrenceElement) fragment.append(eventOccurrenceElement);
      }

      const sidebarEventOccurrencesContainer = this.sidebarContainer.querySelector('#sidebar-event-occurrences-container');
      if (sidebarEventOccurrencesContainer) sidebarEventOccurrencesContainer.replaceChildren(fragment);
      this.sidebarContainer.classList.add('active');
    }
  }
}